module.exports = "/static-assets/_next/static/images/img-15ab42ea35-8500616e325295d83851d0694159e4c1.webp";